var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "lanaya-select",
      style: _vm.widthStyle,
      on: { click: _vm.clickMe }
    },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPlaceholder,
              expression: "showPlaceholder"
            }
          ],
          staticClass: "lanaya-select__placeholder"
        },
        [_vm._v(_vm._s(_vm.placeholder))]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showPlaceholder,
              expression: "!showPlaceholder"
            }
          ],
          staticClass: "lanaya-select__inner"
        },
        [_vm._v(_vm._s(_vm.selectedItemLabel))]
      ),
      _vm._v(" "),
      _c("span", {
        staticClass: "lanaya-select__caret",
        class: _vm.isDropClass
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d141ef0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d141ef0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/select/Select.vue
// module id = 87
// module chunks = 0